import _taggedTemplateLiteral from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var __jsx = React.createElement;
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
/* eslint-disable no-console */
import React, { useEffect, useContext } from 'react';
import Layout from '../../layouts';
import { SiteHeaderFragment } from '../../graphql/fragments/CGQL_SiteHeader';
import { SiteHeaderOldFragment } from '../../graphql/fragments/CGQL_SiteHeaderOld';
import { SiteFooterFragment } from '../../graphql/fragments/CGQL_SiteFooter';
import { SiteCollectionFragment } from '../../graphql/fragments/CGQL_SiteCollection';
import StaffBioDetail from '../../components/organisms/StaffBioDetail';
import { StaffBladeFragment } from '../../graphql/fragments/CGQL_StaffBlade';
import { convert } from 'url-slug';
import { Context, getYext, getYextDivision, getYextInfo, getCountryCode } from '../../global-state-context';
import { config, dynamicStyles, filterAndMapExperiences } from '../../utils';
import Breadcrumbs from '../../components/atoms/Breadcrumbs';
import { BREADCRUMBS_PAGE } from '../../constants/globalConstants';
var isLocal = config.isLocal;
var queries = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$import, gql, siteHeaderQuery, siteHeaderOldQuery, siteFooterQuery, pageQuery, pageQuery1, allExperiencesQuery;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import('@apollo/client');
          case 2:
            _yield$import = _context.sent;
            gql = _yield$import.gql;
            siteHeaderQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n    query DynamicLayoutPages($locale: String, $siteId: Int, $preview: Boolean) {\n      siteCollection(\n        where: { siteId: $siteId }\n        locale: $locale\n        preview: $preview\n      ) {\n        ...SiteHeaderFragment\n      }\n    }\n  "])), SiteHeaderFragment);
            siteHeaderOldQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  query DynamicLayoutPages($locale: String, $siteId: Int, $preview: Boolean) {\n    siteCollection(\n      where: { siteId: $siteId }\n      locale: $locale\n      preview: $preview\n    ) {\n      ...SiteHeaderOldFragment\n    }\n  }\n  "])), SiteHeaderOldFragment);
            siteFooterQuery = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n    query DynamicLayoutPages($locale: String, $siteId: Int, $preview: Boolean) {\n      siteCollection(\n        where: { siteId: $siteId }\n        locale: $locale\n        preview: $preview\n      ) {\n        ...SiteFooterFragment\n      }\n    }\n  "])), SiteFooterFragment);
            pageQuery = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  query StaffDetail($locale: String, $siteId: Int, $preview: Boolean) {\n    siteCollection(\n      where: { siteId: $siteId }\n      locale: $locale\n      preview: $preview\n    ) {\n      ...SiteCollectionFragment\n    }\n  }\n  "])), SiteCollectionFragment);
            pageQuery1 = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  query DynamicLayoutPage($locale: String, $siteId: Int, $preview: Boolean) {\n    siteCollection(\n      where: { siteId: $siteId }\n      locale: $locale\n      preview: $preview\n    ) {\n      items {\n        sitePagesCollection {\n          items {\n            sys {\n              id\n            }\n            url\n            removeFooter\n            removeHeader\n            titleTag\n            itemsCollection {\n              items {\n                ... on StaffBlade {\n                  ...StaffBladeFragment\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  "])), StaffBladeFragment);
            allExperiencesQuery = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  {\n    ntExperienceCollection(limit: 500, preview: true) {\n      items {\n        sys {\n          id\n        }\n        ntName\n        ntConfig\n        ntType\n        ntAudience {\n          ntAudienceId\n          ntName\n          ntDescription\n        }\n        ntDescription\n        ntVariantsCollection(limit: 10) {\n          items {\n            ... on Entry {\n              sys {\n                id\n              }\n              __typename\n            }\n          }\n        }\n      }\n    }\n  }\n  "])));
            return _context.abrupt("return", {
              siteHeaderQuery: siteHeaderQuery,
              siteHeaderOldQuery: siteHeaderOldQuery,
              siteFooterQuery: siteFooterQuery,
              pageQuery: pageQuery,
              pageQuery1: pageQuery1,
              allExperiencesQuery: allExperiencesQuery
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function queries() {
    return _ref.apply(this, arguments);
  };
}();
var StaffDetail = function StaffDetail(_ref2) {
  var _siteCollectionData$s3, _siteCollectionData$s4;
  var siteCollectionData = _ref2.siteCollectionData,
    headerData = _ref2.headerData,
    footerData = _ref2.footerData,
    path = _ref2.path,
    staffArray = _ref2.staffArray,
    allExperiences = _ref2.allExperiences,
    instantPreviewSiteId = _ref2.instantPreviewSiteId,
    instantPreviewEdit = _ref2.instantPreviewEdit;
  var _useContext = useContext(Context),
    yextContactInformationData = _useContext.yextInfo,
    storeYextInfo = _useContext.storeYextInfo;
  useEffect(function () {
    if (typeof window !== 'undefined' && isLocal) {
      var _siteCollectionData$s, _siteCollectionData$s2;
      console.log('%callExperiences', 'color:green', allExperiences);
      console.log('%cdata', 'color:green', siteCollectionData === null || siteCollectionData === void 0 ? void 0 : (_siteCollectionData$s = siteCollectionData.siteCollection) === null || _siteCollectionData$s === void 0 ? void 0 : (_siteCollectionData$s2 = _siteCollectionData$s.items) === null || _siteCollectionData$s2 === void 0 ? void 0 : _siteCollectionData$s2[0]);
      console.log('%cheaderData', 'color:green', headerData);
      console.log('%cfooterData', 'color:green', footerData);
      console.log('%cstaffArray', 'color:green', staffArray);
    }
  }, []);
  var siteData = (siteCollectionData === null || siteCollectionData === void 0 ? void 0 : siteCollectionData.siteCollection) && (siteCollectionData === null || siteCollectionData === void 0 ? void 0 : (_siteCollectionData$s3 = siteCollectionData.siteCollection) === null || _siteCollectionData$s3 === void 0 ? void 0 : _siteCollectionData$s3.items.length) && (siteCollectionData === null || siteCollectionData === void 0 ? void 0 : (_siteCollectionData$s4 = siteCollectionData.siteCollection) === null || _siteCollectionData$s4 === void 0 ? void 0 : _siteCollectionData$s4.items[0]) || {};
  useEffect(function () {
    // save the instant preview site ID to localStorage
    if (typeof window) {
      console.log("> StaffDetail instantPreviewSiteId:".concat(instantPreviewSiteId, " ").concat(instantPreviewEdit));
      instantPreviewSiteId ? localStorage.setItem('instantPreviewSiteId', instantPreviewSiteId) : localStorage.removeItem('instantPreviewSiteId');
      instantPreviewEdit ? localStorage.setItem('instantPreviewEdit', instantPreviewEdit) : localStorage.removeItem('instantPreviewEdit');
    }
    if (!siteCollectionData) {
      return;
    }
    if (yextContactInformationData !== null) {
      return;
    }
    var mainYextId = siteData.locationContactInformation && siteData.locationContactInformation.yextIds || '';
    if ((mainYextId === null || mainYextId === void 0 ? void 0 : mainYextId.length) === 0) {
      return;
    }
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var yextInformation;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getYextInfo(mainYextId);
            case 2:
              yextInformation = _context2.sent;
              storeYextInfo(yextInformation);
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [siteCollectionData, instantPreviewSiteId]);
  if (siteCollectionData) {
    var _staffArray$, _siteData$enableBread;
    var globalFooterData = footerData || {};
    var contentfulAlert = siteCollectionData.alertCollection && siteCollectionData.alertCollection.items.length && siteCollectionData.alertCollection.items[0] || {};
    var locationName = yextContactInformationData && (yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.locationName);
    var _pagePath = {
        pagePath: {}
      },
      pagePath = _pagePath.pagePath;
    var pageTitle = ((_staffArray$ = staffArray[0]) === null || _staffArray$ === void 0 ? void 0 : _staffArray$.staffName) || '';
    return __jsx(Layout, {
      globalHeaderData: headerData,
      globalFooterData: globalFooterData,
      contentfulAlertData: contentfulAlert,
      yextContactInformationData: yextContactInformationData,
      siteData: siteData,
      pageTitle: pageTitle,
      pageDescription: pagePath,
      pagePath: "/staff/".concat(path)
    }, (siteData === null || siteData === void 0 ? void 0 : (_siteData$enableBread = siteData.enableBreadcrumbs) === null || _siteData$enableBread === void 0 ? void 0 : _siteData$enableBread.includes(BREADCRUMBS_PAGE.STAFF_BIO)) && __jsx(Breadcrumbs, {
      data: staffArray[0]
    }), staffArray[0] && __jsx(StaffBioDetail, {
      locationName: locationName,
      staffBioDetailData: staffArray[0]
    }));
  }
  return __jsx("p", null, " Loading ");
};

/*
http://localhost:3000/staff/marie-t/
http://localhost:3000/staff/marie-t:693/
http://localhost:3000/staff/dr-heather-kaplan:415/
*/
export function getStaticProps(_x) {
  return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
  _getStaticProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context) {
    var _process, _process$env, _params$slug, _params$slug2, _params$slug3, _params$slug7, _process2, _process2$env, _process3, _process3$env, _process4, _process4$env, _process5, _process5$env, _process6, _process6$env, _process7, _process7$env, _data$siteCollection, _data$siteCollection$, _data$siteCollection$2, _data$siteCollection2, _data$siteCollection3, _data$siteCollection4, _data$siteCollection5, _staffArray$2, _staffArray$3, _staffArray$3$sys, _staffArray$4, _staffArray$4$sys, _allExperiencesData$n;
    var params, locationSiteId, instantPreviewSiteId, _params$slug4, _params$slug5, slugElements, _params$slug6, staffId, _yield$queries, siteHeaderQuery, siteHeaderOldQuery, siteFooterQuery, pageQuery, pageQuery1, allExperiencesQuery, _yield$import2, apolloClient, _yield$apolloClient$q, allExperiencesData, _yield$apolloClient$q2, siteHeaderData, _yield$apolloClient$q3, siteHeaderOldData, _yield$apolloClient$q4, siteFooterData, _yield$apolloClient$q5, data, _yield$apolloClient$q6, data1, staffArray, headerData, referencedHeader, footerData, dynamicStylesCss, yextData, yextDivision, yextLocationCountry, instantPreviewEdit, allExperiences;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            //context = 'http://localhost:3000/staff/dr-kitty-ferguson';
            params = context.params;
            locationSiteId = parseInt(process.env.NEXT_PUBLIC_SITEID);
            instantPreviewSiteId = null; // if the last array element contains :{number}, it indicates a SITEID
            if (((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true' && (params === null || params === void 0 ? void 0 : (_params$slug = params.slug) === null || _params$slug === void 0 ? void 0 : _params$slug.length) > 0 && params !== null && params !== void 0 && (_params$slug2 = params.slug) !== null && _params$slug2 !== void 0 && _params$slug2[(params === null || params === void 0 ? void 0 : (_params$slug3 = params.slug) === null || _params$slug3 === void 0 ? void 0 : _params$slug3.length) - 1].match(/:\d*$/g)) {
              console.log("> staff/[...slug].js getStaticProps", params === null || params === void 0 ? void 0 : params.slug);
              slugElements = params === null || params === void 0 ? void 0 : (_params$slug4 = params.slug) === null || _params$slug4 === void 0 ? void 0 : _params$slug4[(params === null || params === void 0 ? void 0 : (_params$slug5 = params.slug) === null || _params$slug5 === void 0 ? void 0 : _params$slug5.length) - 1].split(':');
              if (slugElements.length === 2) {
                params.slug[(params === null || params === void 0 ? void 0 : (_params$slug6 = params.slug) === null || _params$slug6 === void 0 ? void 0 : _params$slug6.length) - 1] = slugElements[0];
                locationSiteId = parseInt(slugElements[1]);
                instantPreviewSiteId = locationSiteId;
              }
            }
            staffId = params === null || params === void 0 ? void 0 : (_params$slug7 = params.slug) === null || _params$slug7 === void 0 ? void 0 : _params$slug7[0];
            console.log("> staff/[...slug].js getStaticProps", params === null || params === void 0 ? void 0 : params.slug, "staffId: ".concat(staffId), "locationSiteId: ".concat(locationSiteId));
            _context3.next = 8;
            return queries();
          case 8:
            _yield$queries = _context3.sent;
            siteHeaderQuery = _yield$queries.siteHeaderQuery;
            siteHeaderOldQuery = _yield$queries.siteHeaderOldQuery;
            siteFooterQuery = _yield$queries.siteFooterQuery;
            pageQuery = _yield$queries.pageQuery;
            pageQuery1 = _yield$queries.pageQuery1;
            allExperiencesQuery = _yield$queries.allExperiencesQuery;
            _context3.next = 17;
            return import('../../app/apollo');
          case 17:
            _yield$import2 = _context3.sent;
            apolloClient = _yield$import2.apolloClient;
            _context3.next = 21;
            return apolloClient.query({
              query: allExperiencesQuery,
              variables: {
                offset: 0,
                limit: 10,
                locale: 'en-US',
                siteId: locationSiteId,
                preview: ((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 21:
            _yield$apolloClient$q = _context3.sent;
            allExperiencesData = _yield$apolloClient$q.data;
            _context3.next = 25;
            return apolloClient.query({
              query: siteHeaderQuery,
              variables: {
                locale: 'en-US',
                siteId: locationSiteId,
                preview: ((_process3 = process) === null || _process3 === void 0 ? void 0 : (_process3$env = _process3.env) === null || _process3$env === void 0 ? void 0 : _process3$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 25:
            _yield$apolloClient$q2 = _context3.sent;
            siteHeaderData = _yield$apolloClient$q2.data;
            _context3.next = 29;
            return apolloClient.query({
              query: siteHeaderOldQuery,
              variables: {
                locale: 'en-US',
                siteId: locationSiteId,
                preview: ((_process4 = process) === null || _process4 === void 0 ? void 0 : (_process4$env = _process4.env) === null || _process4$env === void 0 ? void 0 : _process4$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 29:
            _yield$apolloClient$q3 = _context3.sent;
            siteHeaderOldData = _yield$apolloClient$q3.data;
            _context3.next = 33;
            return apolloClient.query({
              query: siteFooterQuery,
              variables: {
                locale: 'en-US',
                siteId: locationSiteId,
                preview: ((_process5 = process) === null || _process5 === void 0 ? void 0 : (_process5$env = _process5.env) === null || _process5$env === void 0 ? void 0 : _process5$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 33:
            _yield$apolloClient$q4 = _context3.sent;
            siteFooterData = _yield$apolloClient$q4.data;
            _context3.next = 37;
            return apolloClient.query({
              query: pageQuery,
              variables: {
                locale: 'en-US',
                siteId: locationSiteId,
                preview: ((_process6 = process) === null || _process6 === void 0 ? void 0 : (_process6$env = _process6.env) === null || _process6$env === void 0 ? void 0 : _process6$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 37:
            _yield$apolloClient$q5 = _context3.sent;
            data = _yield$apolloClient$q5.data;
            _context3.next = 41;
            return apolloClient.query({
              query: pageQuery1,
              variables: {
                locale: 'en-US',
                siteId: locationSiteId,
                preview: ((_process7 = process) === null || _process7 === void 0 ? void 0 : (_process7$env = _process7.env) === null || _process7$env === void 0 ? void 0 : _process7$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 41:
            _yield$apolloClient$q6 = _context3.sent;
            data1 = _yield$apolloClient$q6.data;
            //code foe matching staffname in url-slug format
            staffArray = data1.siteCollection.items[0].sitePagesCollection.items.reduce(function (filteredItemArray, item) {
              item.itemsCollection.items.map(function (field) {
                if ((field === null || field === void 0 ? void 0 : field.__typename) === 'StaffBlade') {
                  field.staffCardCollection.items.map(function (staffCard) {
                    if (staffCard.url ? convert(staffCard.url) === staffId : convert(staffCard.staffName) === staffId) filteredItemArray.push(staffCard);
                  });
                }
              });
              return filteredItemArray;
            }, []);
            referencedHeader = data === null || data === void 0 ? void 0 : (_data$siteCollection = data.siteCollection) === null || _data$siteCollection === void 0 ? void 0 : (_data$siteCollection$ = _data$siteCollection.items) === null || _data$siteCollection$ === void 0 ? void 0 : (_data$siteCollection$2 = _data$siteCollection$[0]) === null || _data$siteCollection$2 === void 0 ? void 0 : _data$siteCollection$2.header;
            if ((referencedHeader === null || referencedHeader === void 0 ? void 0 : referencedHeader.__typename) === 'WebsiteHeaderV2') {
              headerData = siteHeaderData.siteCollection.items[0].header || {};
            } else if ((referencedHeader === null || referencedHeader === void 0 ? void 0 : referencedHeader.__typename) === 'GlobalHeader') {
              headerData = siteHeaderOldData.siteCollection.items[0].header || {};
            }
            footerData = siteFooterData.siteCollection.items[0].footer || {};
            dynamicStylesCss = dynamicStyles.generateDynamicStylesCss(data, headerData, footerData);
            _context3.next = 50;
            return getYext({
              path: staffId,
              siteCollectionData: data
            });
          case 50:
            yextData = _context3.sent;
            yextDivision = getYextDivision(yextData);
            yextLocationCountry = getCountryCode(yextData); // redirect to 404 page if the wrong SITE ID was given
            if (!(!(data !== null && data !== void 0 && (_data$siteCollection2 = data.siteCollection) !== null && _data$siteCollection2 !== void 0 && (_data$siteCollection3 = _data$siteCollection2.items) !== null && _data$siteCollection3 !== void 0 && _data$siteCollection3.length) || (data === null || data === void 0 ? void 0 : (_data$siteCollection4 = data.siteCollection) === null || _data$siteCollection4 === void 0 ? void 0 : (_data$siteCollection5 = _data$siteCollection4.items) === null || _data$siteCollection5 === void 0 ? void 0 : _data$siteCollection5.length) === 0 || !(staffArray !== null && staffArray !== void 0 && (_staffArray$2 = staffArray[0]) !== null && _staffArray$2 !== void 0 && _staffArray$2.staffName))) {
              _context3.next = 55;
              break;
            }
            return _context3.abrupt("return", {
              notFound: true
            });
          case 55:
            // find the current page to get the entry ID
            instantPreviewEdit = staffArray !== null && staffArray !== void 0 && (_staffArray$3 = staffArray[0]) !== null && _staffArray$3 !== void 0 && (_staffArray$3$sys = _staffArray$3.sys) !== null && _staffArray$3$sys !== void 0 && _staffArray$3$sys.id ? "https://app.contentful.com/spaces/".concat(process.env.NEXT_PUBLIC_CONTENTFUL_API_SPACE_ID, "/environments/").concat(process.env.NEXT_PUBLIC_CONTENTFUL_API_ENVIRONMENT, "/entries/").concat(staffArray === null || staffArray === void 0 ? void 0 : (_staffArray$4 = staffArray[0]) === null || _staffArray$4 === void 0 ? void 0 : (_staffArray$4$sys = _staffArray$4.sys) === null || _staffArray$4$sys === void 0 ? void 0 : _staffArray$4$sys.id) : "https://app.contentful.com/spaces/".concat(process.env.NEXT_PUBLIC_CONTENTFUL_API_SPACE_ID, "/environments/").concat(process.env.NEXT_PUBLIC_CONTENTFUL_API_ENVIRONMENT, "/entries");
            console.log('staff/[...slug].js getStaticProps data', staffArray === null || staffArray === void 0 ? void 0 : staffArray[0]);
            allExperiences = filterAndMapExperiences({
              experiences: (_allExperiencesData$n = allExperiencesData.ntExperienceCollection) === null || _allExperiencesData$n === void 0 ? void 0 : _allExperiencesData$n.items
            });
            return _context3.abrupt("return", {
              props: {
                siteCollectionData: data,
                headerData: headerData,
                footerData: footerData,
                allExperiences: allExperiences,
                dynamicStylesCss: dynamicStylesCss,
                dynamicStylesFontsArray: Array.from(dynamicStyles.dynamicStylesFonts),
                path: staffId,
                staffArray: staffArray,
                yextDivision: yextDivision,
                yextLocationCountry: yextLocationCountry,
                instantPreviewSiteId: instantPreviewSiteId,
                instantPreviewEdit: instantPreviewEdit
              },
              revalidate: 1
            });
          case 59:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getStaticProps.apply(this, arguments);
}
export function getStaticPaths() {
  return _getStaticPaths.apply(this, arguments);
}
function _getStaticPaths() {
  _getStaticPaths = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _process8, _process8$env, _data$siteCollection$3, _process9, _process9$env, _process10, _process10$env;
    var locationSiteId, _yield$import3, gql, _yield$import4, apolloClient, _yield$apolloClient$q7, data, arr, paths;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            locationSiteId = parseInt(process.env.NEXT_PUBLIC_SITEID);
            _context4.next = 3;
            return import('@apollo/client');
          case 3:
            _yield$import3 = _context4.sent;
            gql = _yield$import3.gql;
            _context4.next = 7;
            return import('../../app/apollo');
          case 7:
            _yield$import4 = _context4.sent;
            apolloClient = _yield$import4.apolloClient;
            _context4.next = 11;
            return apolloClient.query({
              query: gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      query MyQuery($siteId: Int, $locale: String, $preview: Boolean) {\n        siteCollection(\n          where: { siteId: $siteId }\n          locale: $locale\n          preview: $preview\n        ) {\n          items {\n            sitePagesCollection {\n              items {\n                itemsCollection {\n                  items {\n                    ... on StaffBlade {\n                      staffCardCollection {\n                        items {\n                          staffName\n                          url\n                          sys {\n                            id\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    "]))),
              variables: {
                locale: 'en-US',
                siteId: locationSiteId,
                preview: ((_process8 = process) === null || _process8 === void 0 ? void 0 : (_process8$env = _process8.env) === null || _process8$env === void 0 ? void 0 : _process8$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 11:
            _yield$apolloClient$q7 = _context4.sent;
            data = _yield$apolloClient$q7.data;
            arr = [];
            (_data$siteCollection$3 = data.siteCollection.items[0].sitePagesCollection) === null || _data$siteCollection$3 === void 0 ? void 0 : _data$siteCollection$3.items.map(function (item) {
              var _item$itemsCollection;
              item === null || item === void 0 ? void 0 : (_item$itemsCollection = item.itemsCollection) === null || _item$itemsCollection === void 0 ? void 0 : _item$itemsCollection.items.map(function (blade) {
                var _blade$staffCardColle;
                blade === null || blade === void 0 ? void 0 : (_blade$staffCardColle = blade.staffCardCollection) === null || _blade$staffCardColle === void 0 ? void 0 : _blade$staffCardColle.items.map(function (id) {
                  if (id !== null && id !== void 0 && id.url) {
                    arr.push(id === null || id === void 0 ? void 0 : id.url);
                  } else {
                    arr.push(id === null || id === void 0 ? void 0 : id.staffName);
                  }
                });
              });
            });
            paths = arr.map(function (item) {
              return {
                params: {
                  slug: [convert(item)]
                }
              };
            });
            console.log('> staff/[...slug].js getStaticPaths', locationSiteId,
            // JSON.stringify(paths, null, 4),
            paths.length, (_process9 = process) === null || _process9 === void 0 ? void 0 : (_process9$env = _process9.env) === null || _process9$env === void 0 ? void 0 : _process9$env.NEXT_PUBLIC_ENABLE_PREVIEW);
            return _context4.abrupt("return", {
              paths: paths,
              fallback: ((_process10 = process) === null || _process10 === void 0 ? void 0 : (_process10$env = _process10.env) === null || _process10$env === void 0 ? void 0 : _process10$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true' ? 'blocking' : false // returns true if the preview mode is enabled
            });
          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getStaticPaths.apply(this, arguments);
}
export default StaffDetail;